import { NoResultComponent } from '@/app/components/shared/no-result/no-result.component';
import { SkeletonCompetitionWithMatchesComponent } from '@/app/components/shared/skeleton';
import { RouteValidatorService } from '@/app/services/route-validator.service';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  ElementRef,
  inject,
  viewChild,
} from '@angular/core';
import { EntityFavoriteRowComponent } from '../../components';
import { TeamFavoritesMatchesByDayService } from '../../services';

@Component({
  selector: 'app-my-teams',
  standalone: true,
  imports: [
    NoResultComponent,
    EntityFavoriteRowComponent,
    SkeletonCompetitionWithMatchesComponent,
  ],
  templateUrl: './my-teams.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MyTeamsComponent {
  private observer!: IntersectionObserver;
  private teamFavoritesMatchesByDayService = inject(
    TeamFavoritesMatchesByDayService
  );

  private routeValidatorService = inject(RouteValidatorService);

  fetchStatus = computed(() => ({
    isLoading: this.teamFavoritesMatchesByDayService.isLoadingSoccerMatches(),
    isError: this.teamFavoritesMatchesByDayService.isErrorSoccerMatches(),
  }));

  data = computed(() => ({
    counterMatches: this.teamFavoritesMatchesByDayService.counterMatches(),
    soccerMatches: this.teamFavoritesMatchesByDayService.soccerMatches(),
    pagination: this.teamFavoritesMatchesByDayService.paginationMatches(),
  }));

  scoreContainerRef = viewChild<ElementRef<HTMLDivElement>>(
    'soccerMatchesContainer'
  );
  scrollTriggerRef = viewChild<ElementRef<HTMLDivElement>>('scrollTrigger');

  constructor() {
    this.routeValidatorService.isActiveTabTeamFavorite.set(true);
  }

  ngAfterViewInit() {
    const refItem = this.scrollTriggerRef()?.nativeElement;

    if (!refItem) return;

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (
            entry.isIntersecting &&
            this.teamFavoritesMatchesByDayService.isMoreMatches() &&
            this.teamFavoritesMatchesByDayService.soccerMatches().length > 9
          ) {
            this.teamFavoritesMatchesByDayService.getTeamMatchesFavorites(
              this.teamFavoritesMatchesByDayService.paginationMatches() + 1
            );
          }
        });
      },
      {
        root: null, // null = viewport
        rootMargin: '200px', // Se activará 200px antes de que el elemento sea visible
        threshold: 0.01,
      }
    );

    this.observer.observe(refItem);

    if (!this.teamFavoritesMatchesByDayService.isLoadingSoccerMatches()) {
      this.teamFavoritesMatchesByDayService.getTeamMatchesFavorites();
    }

    // 👉 Primer fetch con skeleton
    if (!this.teamFavoritesMatchesByDayService.isLoadingSoccerMatches()) {
      this.teamFavoritesMatchesByDayService.getTeamMatchesFavorites();
    }
  }

  ngOnDestroy() {
    this.teamFavoritesMatchesByDayService.clearSoccerMatches();
    if (this.observer) {
      this.observer.disconnect();
    }

    this.routeValidatorService.isActiveTabTeamFavorite.set(false);
  }
}
